// extracted by mini-css-extract-plugin
export default {"header":"App_header__fVqRx","link":"App_link__-hns0","button":"App_button__A+YCD","subLink":"App_subLink__oGS6v","dropdownFooter":"App_dropdownFooter__BSVk+"};